module.exports = __webpack_public_path__ + "img/MycouponUsed.2ed5c2cc.png";